import _ from 'lodash';

export interface ITimerState {
  time?: number;
  start?: number;
  isRunning?: boolean;
}

export class Timer {
  /**
   * Timer state object
   * @type {ITimerState}
   */
  state: ITimerState = {
    time: 0,
    start: 0,
    isRunning: false
  } as ITimerState;

  /**
   * Timer instance reference
   */
  private timer: any;

  constructor(props: any) {
    _.assign(this, props);
  }

  /**
   * Returns timer running state
   * @return {boolean}
   */
  private isRunning = (): boolean => !!this.state.isRunning;

  /**
   * Returns timer start time. A moment when start fn was triggered
   * @return {number}
   */
  private getStartTime = (): number => this.state.start || 0;

  /**
   * Returns timer running time lapse.
   * @return {number}
   */
  private getTime = (): number => (this.state.time || 0) * 1000;

  /**
   * Sets timer state object
   * @param {ITimerState} state
   */
  private setTimerState = (state: ITimerState) => {
    _.assign(this.state, state);
  };

  /**
   * Resets timer by calling stop fn first and starting timer with previously set time
   */
  public reset = () => {
    this.stop();

    // @ts-ignore
    let time = this.state.time || 0;
    this.start(time);
  };

  /**
   * Starts timer with specified time lapse
   * @param {number} time
   */
  public start = (time: number) => {
    this.setTimerState({
      time: time,
      start: Date.now(),
      isRunning: true
    });

    this.timer = setInterval(this.onIntervalChange, 1000);
  };

  /**
   * Stops timer
   */
  public stop = () => {
    this.setTimerState({ isRunning: false });
    clearInterval(this.timer);
  };

  /**
   * Handles interval change event and detects if timer is finished
   */
  onIntervalChange = () => {
    let timeLeft = (this.getTime() - (Date.now() - this.getStartTime())) as number;
    timeLeft = ~~(timeLeft / 1000) as number;
    this.onTimerChange(timeLeft);

    if ((!timeLeft || timeLeft < 0) && this.state.isRunning) {
      this.setTimerState({
        isRunning: false
      });

      this.onTimerFinish();
    }

    if (!this.isRunning()) {
      this.stop();
    }
  };

  /**
   * Public onTimerChange fn
   * This should be provided by parent as callback method
   * @param {number} timeLeft
   */
  onTimerChange = (timeLeft: number) => {};

  /**
   * Public onTimerFinish fn
   * This should be provided by parent as callback method
   */
  onTimerFinish = () => {};
}
